import type { ConfirmDialogElement } from './panels/confirm-dialog-lit.js';
import { t } from './i18n.js';

export async function resolveMapSaveConflict(deps: {
  choose: ConfirmDialogElement['requestChoice'];
  reload(): Promise<void>;
}): Promise<'copy' | 'cancel'> {
  const choice = await deps.choose({
    title: t('save.conflict_title'), message: t('save.conflict_message'),
    confirmLabel: t('save.conflict_copy'), alternativeLabel: t('save.conflict_reload'), cancelLabel: t('confirm.cancel'),
  });
  if (choice === 'confirm') return 'copy';
  if (choice === 'alternative') await deps.reload();
  return 'cancel';
}
